exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-container[data-v-16da664e]{height:100%}.page-container .changePwd[data-v-16da664e]{padding:20px 50px;background-color:#fff;border-radius:6px;margin:50px auto 0;width:50%}.page-container .form-footer[data-v-16da664e]{text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-16da664e","scoped":true,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/view/user/baseInfo/companychangePassword.vue
// module id = 31FW
// module chunks = 1